import { Box, Flex, IconButton, Image } from '@chakra-ui/react'
import { useContext } from 'react'
import { NavbarContext } from '../../Context/NavbarContext'
import { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'

const NavbarOpen = () => {
  const navigate = useNavigate()
  const { isNavbarOpen, toggleNavbar, setCurrentPath } =
    useContext(NavbarContext)
  if (isNavbarOpen) {
    return <Box h='40px' />
  }

  const user = localStorage.getItem('token') ?? null

  return (
    <>
      {user ? (
        <Flex h='40px' w='100%'>
          <IconButton
            onClick={() => toggleNavbar()}
            aria-label='Open Navbar'
            icon={<Image src='/assets/icons/hamburger.svg' />}
            colorScheme='brandWhite'
            mr={1}
            position='absolute'
            top={4}
            left='20px'
          />
          <IconButton
            onClick={() => {
              setCurrentPath(['transcripts-summaries'])
              navigate('/transcripts-summaries')
            }}
            aria-label='Home'
            icon={<Image src='/assets/icons/home.svg' />}
            colorScheme='brandWhite'
            position='absolute'
            top={4}
            left='64px'
          />
        </Flex>
      ) : (
        <Flex border='1px' borderColor='blackAlpha.50' w='100%' h='70px'>
          <IconButton
            aria-label='Logo'
            icon={<Image src='/assets/images/logo.png' boxSize='30px' />}
            colorScheme='brandWhite'
            mr={1}
            position='absolute'
            top={4}
            left='30px'
            size='lg'
          />
        </Flex>
      )}
    </>
  )
}

export default NavbarOpen
